/**
 * ------------------------------------------------------------
 * Custom About Story
 * IndianVastraa Premium Theme
 * ------------------------------------------------------------
 */

(() => {

    'use strict';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = document.querySelectorAll('.about-story-section');

    if (!sections.length) return;

    /* ==========================================================
       Scroll Animation
    ========================================================== */

    if (!reduceMotion && 'IntersectionObserver' in window) {

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            root: null,
            threshold: 0.2,
            rootMargin: '0px 0px -60px 0px'
        });

        sections.forEach(section => observer.observe(section));

    } else {
        sections.forEach(section => {
            section.classList.add('is-visible');
        });
    }

    /* ==========================================================
       Luxury Mouse Parallax
    ========================================================== */

    if (reduceMotion) return;

    sections.forEach(section => {

        const media = section.querySelector('.about-story__media');
        if (!media) return;

        let animationFrame = null;

        media.addEventListener('mousemove', (event) => {

            if (animationFrame) cancelAnimationFrame(animationFrame);

            animationFrame = requestAnimationFrame(() => {
                const rect = media.getBoundingClientRect();
                const x = event.clientX - rect.left;
                const y = event.clientY - rect.top;

                const rotateY = ((x / rect.width) - 0.5) * 6;
                const rotateX = ((0.5 - (y / rect.height))) * 6;

                media.style.transform = `
                    perspective(1200px)
                    rotateX(${rotateX}deg)
                    rotateY(${rotateY}deg)
                    translateZ(0)
                `;
            });
        });

        media.addEventListener('mouseleave', () => {

            media.style.transition = 'transform .6s cubic-bezier(.2,.8,.2,1)';
            media.style.transform = `
                perspective(1200px)
                rotateX(0deg)
                rotateY(0deg)
            `;

            setTimeout(() => {
                media.style.transition = '';
            }, 600);

        });
    });

    /* ==========================================================
       Floating Small Image
    ========================================================== */

    sections.forEach(section => {

        const smallImage = section.querySelector('.about-story__image-small');
        if (!smallImage || reduceMotion) return;

        let start = null;

        function animate(timestamp) {
            if (!start) start = timestamp;
            const progress = (timestamp - start) / 1000;
            const translateY = Math.sin(progress * 1.4) * 6;
            smallImage.style.transform = `translateY(${translateY}px)`;
            requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);

    });

})();